import { createRoot } from "react-dom/client";
import { Router, useRoute, Link } from "./lib/router";
import { useData } from "./lib/events";
import { Shows, Show, Apply } from "./pages/Shows";
import { Manage } from "./pages/Manage";
import { Login } from "./pages/Login";
function App() {
  const path = useRoute(),
    { data: session } = useData("/api/session");
  const match = path.match(/^\/events\/([^/]+)(\/apply)?$/);
  return (
    <>
      {document.documentElement.dataset.preview === "true" && <div className="preview-bar">
        LOCAL PREVIEW <span>Demo shows · nothing is sent to production</span>
      </div>}
      <header>
        <Link href="/" className="brand">
          <img src="/logo.png" alt="" />
          ON TAP <span>COMEDY</span>
        </Link>
        <nav>
          <Link href="/events">The shows</Link>
          <Link href="/signup">Get on stage</Link>
          {session?.owner && (
            <Link href="/manage" className="owner-link">
              Manage shows ↗
            </Link>
          )}
        </nav>
      </header>
      <main>
        {path === "/login" ? (
          <Login signedIn={session?.owner} />
        ) : path === "/manage" || path === "/contacts" ? (
          <Manage />
        ) : match ? (
          match[2] ? (
            <Apply key={match[1]} slug={match[1]} />
          ) : (
            <Show key={match[1]} slug={match[1]} />
          )
        ) : ["/", "/events", "/signup"].includes(path) ? (
          <Shows signup={path === "/signup"} />
        ) : (
          <p>Page not found.</p>
        )}
      </main>
      <footer>
        <strong>ON TAP COMEDY</strong>
        <span>Fresh comedy. Cold drinks. Barcelona.</span>
        <Link href={session?.owner ? "/manage" : "/login"}>{session?.owner ? "Manage shows ↗" : "Owner sign in ↗"}</Link>
      </footer>
    </>
  );
}
createRoot(document.getElementById("root")!).render(
  <Router>
    <App />
  </Router>,
);
